
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/understanding-the-ripple-effect",
      function () {
        return require("private-next-pages/articles/understanding-the-ripple-effect.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/understanding-the-ripple-effect"])
      });
    }
  